import { Box, Button, Grid, Typography } from '@mui/material';
import { MFTextField } from '../../lib/formik';
import { Formik, useFormikContext, validateYupSchema, yupToFormErrors } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {
  Distributor,
  getDistributors,
  getDistributorsResponse,
  getRms,
  getRmsResponse,
  SubDistributor,
} from '../../redux-store/actions';
import React, { useEffect, useState } from 'react';
import { RootStateType } from '../../redux-store/reducers';
import { updateApplication } from '../../redux-store/actions/application';
import { useHistory, useParams } from 'react-router';
import {
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  CustodianMaster,
  DISTRIBUTOR_DETAILS_ERRORS,
  NDPSMBankMaster,
  SAVE_LATER_VALIDATION_CHECK,
  USER_ROLES,
  addressForTaxsMasters,
} from '../../utils/constant';
import { InfoDialog, Notes, ProceedSaveLater, SubHeading } from './components';
import UseRadioGroup from '../../lib/formik/Radio';
import { distributorsValidationSchema } from '../../utils/schema';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  applicationComparison,
  applyRoleBasedStatus,
  checkNDPMS,
  disableBankDetail,
  getAllStrategiesByDistributorType,
  getApplicantIdForInvestorPhotoCapture,
  isBankDetailsChanged,
  isCreatedByUser,
  isCustodianKotak,
  saveForLater,
  saveForLaterInvestorPhotoCapture,
  shouldValidateUponSaveLater,
  showPopBankDetail,
} from '../../utils/utilityFunctions';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { ConfirmationDialog } from '../commonComponents';
import MFSelectField from '../../lib/formik/SelectField';
import { useSnackbar } from 'notistack';
import { OnEditDialogBox } from './additionalKYCDetails';
import { refLoginCheck } from '../Investments/investor-application';
import {
  ApplicantAddressType,
  ApplicationProps,
  RMType,
  StrategyDetailsType,
} from '../../redux-store/types/api-types';
import FieldValidationNote from './FieldValidationNote';
import { GetStrategiesResponseBody } from '../../redux-store/types/strategies';
import { showError } from '../../redux-store/actions/auth';

type DistributorDetailsProps = {
  distributorName: string | null;
  distributorId: number | null;
  distributorEmail: string | null;
  distributorPhone: string | null;
  // distributorAprn: string | null;
  loginType: string;
  firstName: string;
  empCode: string;
  rmId: number | null;
  rmEmail: string | null;
  rmPhone: string | null;
  rmName: string | null;
  subdistributorId: number | null;
  subdistributorName: string | null;
  subdistributorEmail: string | null;
  subdistributorPhone: string | null;
  subdistributorEuin: string | null;
  filledBy: string | null;
  saveType: string;
  custodian: string;
  bankDetails: string | null;
  distributorType: string | null;
};

function GridItem({ children }: { children: React.ReactNode }) {
  return (
    <Grid item xs={12} sm={6}>
      {children}
    </Grid>
  );
}

const RMDetail = ({ rms, values }: { rms: RMType[]; values: DistributorDetailsProps }) => {
  const { role, id: authId = '' } = useSelector((store: RootStateType) => store.auth);
  const referenceDetail = useSelector((store: RootStateType) => store.refrenceIdReducer);
  const { application } = useSelector((store: RootStateType) => store.application);
  const amcuserAsInvestor = refLoginCheck(
    authId,
    application as unknown as ApplicationProps,
    referenceDetail
  );
  const { setValues } = useFormikContext();

  return (
    <>
      {rms.length > 0 ? (
        <>
          <GridItem>
            <SearchableSelect
              name="rmId"
              label="RM Name *"
              items={rms
                .sort((rm1, rm2) =>
                  (rm1['name'] || '').toString().localeCompare((rm2['name'] || '').toString())
                )
                .map((item) => {
                  return {
                    key: item.name || 'NA',
                    value: item.id,
                  };
                })}
              onChange={({ target: { value } }) => {
                const rmCode = rms.find((item) => item.id === value);
                const { id = null, name } = rmCode || {};
                const { email = '', phone = '' } = rmCode?.user || {};
                setValues({
                  ...values,
                  rmId: id,
                  rmEmail: email,
                  rmPhone: phone,
                });
              }}
              disabled={
                [USER_ROLES.RM, USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role) ||
                amcuserAsInvestor ||
                !isCreatedByUser(application?.createdBy || '', authId)
              }
              // applyRenderValue={true}
              searchFieldPlaceholder={'Search RM'}
            />
          </GridItem>
          <GridItem>
            <MFTextField
              name="rmEmail"
              label="RMs Email Address"
              placeholder="Enter RM Email ID"
              disabled={true}
            />
          </GridItem>
          <GridItem>
            <MFTextField
              name="rmPhone"
              label="RMs Mobile Number"
              placeholder="Enter RMs Mobile Number"
              disabled={true}
            />
          </GridItem>
          {/* <GridItem>
        <MFTextField
          name="empCode"
          label="Employee Code"
          placeholder="Enter Employee Code"
          disabled={true}
        />
      </GridItem> */}
        </>
      ) : (
        <>
          <GridItem>
            <MFTextField
              name="firstName"
              label="RMs Name"
              placeholder="Enter RM name"
              disabled={true}
            />
          </GridItem>
          <GridItem>
            <MFTextField
              name="rmEmail"
              label="RMs Email Address"
              placeholder="Enter RM Email ID"
              disabled={true}
            />
          </GridItem>
          <GridItem>
            <MFTextField
              name="rmPhone"
              label="RMs Mobile Number"
              placeholder="Enter RMs Mobile Number"
              disabled={true}
            />
          </GridItem>
        </>
      )}
    </>
  );
};

const DistributorDetail = ({
  distributors,
  values,
  selectedDistributor,
  setSelectedDistributor,
}: {
  distributors: Distributor[];
  values: DistributorDetailsProps;
  selectedDistributor: SubDistributor[];
  setSelectedDistributor: (distributor: SubDistributor[]) => void;
}): JSX.Element => {
  const { role, id: authId = '' } = useSelector((store: RootStateType) => store.auth);

  const { setValues } = useFormikContext();
  const [open, setOpen] = useState(false);
  const [openDialog, setDialog] = useState(false);
  const referenceDetail = useSelector((store: RootStateType) => store.refrenceIdReducer);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { createdBy = '' } = application || {};
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const amcuserAsInvestor = refLoginCheck(
    authId,
    application as unknown as ApplicationProps,
    referenceDetail
  );

  const handleDialogOpen = () => {
    setDialog(true);
  };
  const handleDialogClose = () => {
    setDialog(false);
  };
  const shouldClear = isCreatedByUser(application?.createdBy || '', authId);
  return (
    <>
      {distributors.length > 0 ? (
        <>
          {[USER_ROLES.RM].includes(role) && values.distributorId && shouldClear && (
            <Grid item xs={12} sx={{ textAlign: 'right' }}>
              <Button
                variant="contained"
                sx={{
                  color: 'white',
                  fontWeight: 500,
                  fontSize: 14,
                  py: 0.5,
                  px: 3,
                }}
                onClick={handleDialogOpen}>
                Clear
              </Button>
            </Grid>
          )}
          <GridItem>
            <SearchableSelect
              name="distributorId"
              label="Distributor Code *"
              items={distributors
                .sort((distributor1, distributor2) =>
                  (distributor1['name'] || '')
                    .toString()
                    .localeCompare((distributor2['name'] || '').toString())
                )
                .map((item) => ({
                  key: (item.name || 'NA') + ' - ' + item.arnCode,
                  value: item.id,
                }))}
              onChange={({ target: { value } }) => {
                const distributorCode = distributors.find((item) => item.id === value);
                const { id = null, name, type } = distributorCode || {};
                const { email = '', phone = '' } = distributorCode?.user || {};
                setValues({
                  ...values,
                  distributorName: name,
                  distributorId: id,
                  distributorEmail: email,
                  distributorPhone: phone,
                  // distributorAprn: aprn,
                  subdistributorId: null,
                  subdistributorName: null,
                  subdistributorEmail: null,
                  subdistributorPhone: null,
                  subdistributorEuin: null,
                  distributorType: type,
                });
                setSelectedDistributor(
                  distributors.find((distributor) => distributor.id === value)?.subdistributors ||
                    []
                );
              }}
              disabled={
                [
                  USER_ROLES.DISTRIBUTOR,
                  USER_ROLES.INVESTOR,
                  USER_ROLES.POAAPPROVER,
                  USER_ROLES.SUBDISTRIBUTOR,
                ].includes(role) ||
                amcuserAsInvestor ||
                !isCreatedByUser(application?.createdBy || '', authId)
              }
              applyRenderValue={true}
              searchFieldPlaceholder={'Search Distributor'}
            />
          </GridItem>
          <GridItem>
            <MFTextField
              name="distributorName"
              label="Distributor/IFA Name *"
              placeholder="Enter Distributor name"
              disabled={true}
            />
          </GridItem>
          {values.distributorType === 'individual' && (
            <>
              <GridItem>
                <MFTextField
                  name="distributorEmail"
                  label="Distributor/IFA Email *"
                  placeholder="Enter Distributor email"
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="distributorPhone"
                  label="Distributor/IFA Phone *"
                  placeholder="Enter Distributor phone"
                  disabled={true}
                />
              </GridItem>
            </>
          )}
          {/* {values.distributorType !== 'individual' && (
            <GridItem>
              <MFTextField
                name="distributorAprn"
                label="Distributor/IFA APRN *"
                placeholder="Enter Distributor APRN"
                disabled={true}
              />
            </GridItem>
          )} */}
          {!!selectedDistributor?.length && (
            <>
              <GridItem>
                <SearchableSelect
                  name="subdistributorId"
                  label="Distributor's RM Code *"
                  items={selectedDistributor
                    .sort((subDistributor1, subDistributor2) =>
                      (subDistributor1.user['firstName'] || '')
                        .toString()
                        .localeCompare((subDistributor2.user['firstName'] || '').toString())
                    )
                    .map((item) => ({
                      key: item.user.firstName + ' - ' + (item.distributors_RM_Code || 'NA'),
                      value: item.id,
                    }))}
                  onChange={({ target: { value } }) => {
                    const distributorCode = selectedDistributor.find((item) => item.id === value);
                    const { id = null, user, euin } = distributorCode || {};
                    const { email, firstName = '', phone } = user || {};
                    setValues({
                      ...values,
                      subdistributorId: id,
                      subdistributorEmail: email,
                      subdistributorName: firstName,
                      subdistributorEuin: euin,
                      subdistributorPhone: phone,
                    });
                  }}
                  disabled={
                    [
                      USER_ROLES.DISTRIBUTOR,
                      USER_ROLES.INVESTOR,
                      USER_ROLES.POAAPPROVER,
                      USER_ROLES.SUBDISTRIBUTOR,
                    ].includes(role) || amcuserAsInvestor
                  }
                  searchFieldPlaceholder={"Search Distributor's RM"}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="subdistributorName"
                  label="Distributor's RM Name *"
                  placeholder="Enter Distributor name"
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="subdistributorEmail"
                  label="Distributor's RM Email *"
                  placeholder="Enter Distributor email"
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="subdistributorPhone"
                  label="Distributor's RM Phone *"
                  placeholder="Enter Distributor phone"
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="subdistributorEuin"
                  label="Distributor's RM EUIN *"
                  placeholder="Enter Distributor EUIN"
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <SearchableSelect
                  name="subdistributorId"
                  label="Distributor RM/Advisor Name-Location *"
                  items={selectedDistributor
                    .sort((subDistributor1, subDistributor2) =>
                      (subDistributor1.user['firstName'] || '')
                        .toString()
                        .localeCompare((subDistributor2.user['firstName'] || '').toString())
                    )
                    .map((item) => ({
                      key: item.user.firstName + ' - ' + (item.distributors_RM_Code || 'NA'),
                      value: item.id,
                    }))}
                  onChange={({ target: { value } }) => {
                    const distributorCode = selectedDistributor.find((item) => item.id === value);
                    const { id = null, user, euin } = distributorCode || {};
                    const { email, firstName = '', phone } = user || {};
                    setValues({
                      ...values,
                      subdistributorId: id,
                      subdistributorEmail: email,
                      subdistributorName: firstName,
                      subdistributorEuin: euin,
                      subdistributorPhone: phone,
                    });
                  }}
                  disabled={
                    [
                      USER_ROLES.DISTRIBUTOR,
                      USER_ROLES.INVESTOR,
                      USER_ROLES.POAAPPROVER,
                      USER_ROLES.SUBDISTRIBUTOR,
                    ].includes(role) || amcuserAsInvestor
                  }
                  searchFieldPlaceholder={"Search Distributor's RM"}
                />
              </GridItem>
            </>
          )}
          <GridItem>
            <MFTextField name="filledBy" label="Filled by" placeholder="Enter filled by" />
            <Typography
              component="span"
              sx={{ position: 'relative', left: 64, bottom: { xs: 85, md: 91 } }}>
              <InfoOutlinedIcon color="info" fontSize="small" onClick={handleOpen} />
            </Typography>
          </GridItem>
          <InfoDialog
            onClose={handleClose}
            open={open}
            content={'Please add the Name of the Subdistributor RM.'}
          />
        </>
      ) : (
        <Grid
          xs={12}
          sm={12}
          sx={{
            fontSize: 18,
            fontWeight: 500,
            color: '#2057A6',
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            justifyContent: 'center',
            mt: { lg: 9, xs: 9 },
            mb: 2.9,
            ml: { xs: 3 },
          }}>
          No distributor mapped under this RM
        </Grid>
      )}
      <ConfirmationDialog
        message={`Are you sure you want to clear Distributor details ?`}
        open={openDialog}
        setOpen={handleDialogClose}
        onSave={() => {
          handleDialogClose();
          setValues({
            ...values,
            distributorName: '',
            distributorId: null,
            distributorEmail: '',
            distributorPhone: '',
            distributorAprn: '',
            subdistributorId: null,
            subdistributorName: '',
            subdistributorEmail: '',
            subdistributorEuin: '',
            subdistributorPhone: '',
            distributorType: '',
          });
          setSelectedDistributor([]);
        }}
        onCancel={handleDialogClose}
      />
    </>
  );
};

export default function DistributorDetails(): JSX.Element {
  const dispatch = useDispatch();
  const history = useHistory();
  const [distributors, setDistributors] = useState<Distributor[]>([]);
  const [rms, setRms] = useState<RMType[]>([]);
  const [rmIds, setRmIds] = useState<number[]>([]);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role, id: authId = '' } = useSelector((store: RootStateType) => store.auth);
  const [selectedDistributor, setSelectedDistributor] = useState<SubDistributor[]>([]);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const referenceDetail = useSelector((store: RootStateType) => store.refrenceIdReducer);
  const [showDialogForEdit, setShowShowForEdit] = useState(false);
  const [finalvalue, setFinalValue] = useState<any>();
  const [buttonDisable, setButtonDisable] = useState(false);
  const {
    distributor,
    rm,
    subdistributorId = null,
    subDistributor,
    filledBy = '',
    custodian = '',
    bankDetails = '',
    accountType,
    bankAccountTypeNdpms = '',
  } = application || {};

  const {
    name,
    id,
    type,
    user: { email: disEmail = '', phone: disPhone = '' },
  } = distributor || {
    arnCode: '',
    name: '',
    id: null,
    user: { email: '', phone: '' },
    // aprn: '',
  };

  const {
    empCode,
    id: rmId,
    user: { email: RMEmail = '', firstName: RMFirstName = '', phone: RMPHone = '' },
  } = rm || { empCode: '', rmId: null, user: { email: '', phone: '' } };

  const {
    user: { firstName: subdistributorName, email: subdistributorEmail, phone: subdistributorPhone },
  } = subDistributor || { user: { firstName: '', email: '', phone: '' } };

  const initialValues: DistributorDetailsProps = {
    distributorId: id,
    distributorName: name,
    distributorEmail: disEmail,
    distributorPhone: disPhone,
    // distributorAprn: aprn || '',
    loginType: role === USER_ROLES.RM ? 'rm' : 'distributor',
    empCode,
    rmId: rmId || null,
    firstName: RMFirstName,
    rmEmail: RMEmail,
    rmPhone: RMPHone,
    rmName: RMFirstName,
    subdistributorId: subdistributorId === null ? subdistributorId : Number(subdistributorId),
    subdistributorName,
    subdistributorEmail,
    subdistributorPhone,
    subdistributorEuin: subDistributor?.euin || '',
    filledBy,
    saveType: 'save and proceed',
    custodian,
    bankDetails,
    distributorType: type || '',
  };

  useEffect(() => {
    let isComponentActive = true;
    (async function () {
      try {
        if (Object.keys(application || {}).length && [USER_ROLES.RM].includes(role)) {
          const res = (await dispatch(
            getDistributors({ isActive: true })
          )) as unknown as getDistributorsResponse;
          const { distributors = [] } = res || {};
          const updatedDistributor =
            application?.distributor_id && !application.distributor.isActive
              ? [
                  ...distributors,
                  {
                    ...application.distributor,
                    subdistributors: [application.subDistributor],
                  } as Distributor,
                ]
              : distributors;
          if (isComponentActive) {
            const updateSubdistributor =
              application?.distributor_id &&
              application?.distributor.isActive &&
              application?.subdistributorId &&
              !application.subDistributor?.isActive
                ? [
                    ...(updatedDistributor.find((distributor) => distributor.id === id)
                      ?.subdistributors || []),
                    { ...application.subDistributor },
                  ]
                : updatedDistributor.find((distributor) => distributor.id === id)
                    ?.subdistributors || [];
            setSelectedDistributor(updateSubdistributor as unknown as SubDistributor[]);
            setDistributors(updatedDistributor as unknown as Distributor[]);

            // console.log(loginType, 'selected distri');
          }
        } else if (
          Object.keys(application || {}).length &&
          [USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR].includes(role)
        ) {
          if (application?.distributor) {
            setDistributors([application.distributor as Distributor]);
            if (application.subDistributor) {
              setSelectedDistributor([
                {
                  ...application.subDistributor,
                  id: Number(application.subDistributor.id),
                } as SubDistributor,
              ]);
            }
          }
          // Pass distributorId if distributor type is 'company'
          const distributorType = application?.distributor?.type;
          const distributorId =
            distributorType === 'company' && application?.subDistributor
              ? Number(application.subDistributor.distributorId)
              : undefined;
          const rmsRes = (await dispatch(
            distributorType === 'company' && distributorId
              ? getRms({ isActive: true, distributorId })
              : getRms({ isActive: true })
          )) as unknown as getRmsResponse;
          const { rmDetails = [] } = rmsRes || {};
          // If application has an RM that is not active, add it to the list
          const updatedRms =
            application?.rm && !application.rm.isActive
              ? [...rmDetails, application.rm as RMType]
              : rmDetails;
          setRms(updatedRms as unknown as RMType[]);
          // Optionally, update rmIds if you need them elsewhere
          const rmIds = updatedRms.map((rm) => rm.id) || [];
          setRmIds(rmIds);
        } else {
          const { distributor, subDistributor } = application || {};
          setDistributors(distributor ? [distributor as Distributor] : []);
          setSelectedDistributor(
            subDistributor
              ? [{ ...subDistributor, id: Number(subDistributor.id) } as SubDistributor]
              : []
          );
        }
      } catch (e: unknown) {
        console.error((e as Error).message);
      }
    })();
    return () => {
      isComponentActive = false;
    };
  }, [application]);

  const { referenceId: referenceIdForInvestorPhotoCapture } = useParams<{ referenceId: string }>();
  const handleapplicationComparison = (
    values: DistributorDetailsProps,
    application: ApplicationProps | null,
    applicationStrategydetails = {},
    strategiesFeeType = application?.strategiesFeeType || '',
    applicants = application?.applicants,
    isSaveLater: boolean
  ): boolean => {
    const { distributorId, subdistributorId, rmId, filledBy, custodian, bankDetails, saveType } =
      values;
    return applicationComparison(application, {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      ...application!,
      distributor_id: distributorId,
      subdistributorId: subdistributorId ? subdistributorId.toString() : subdistributorId,
      rm_id: rmId,
      filledBy: filledBy,
      custodian,
      bankDetails: checkNDPMS(accountType) ? bankDetails : '',
      currentStep: SAVE_LATER_VALIDATION_CHECK
        ? application?.currentStep === null
          ? 1
          : application?.currentStep
        : isSaveLater
        ? 0
        : application?.currentStep || 1,
      ...applicationStrategydetails,
      applicants,
      strategiesFeeType,
    });
  };
  const onSubmit = async (values: DistributorDetailsProps) => {
    try {
      const { distributorId, subdistributorId, rmId, filledBy, custodian, bankDetails, saveType } =
        values;
      const {
        id,
        applicant1ReferenceId,
        currentStep = null,
        banks,
        status,
        hasPOA,
        applicationNumber,
      } = application || {};
      if (!rmId && [USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR].includes(role)) {
        throw DISTRIBUTOR_DETAILS_ERRORS;
      }
      const isSaveLater = saveType !== 'save and proceed';
      let applicationStrategydetails = {};
      let response = [] as GetStrategiesResponseBody[];
      let strategiesFeeType = application?.strategiesFeeType || '';
      let applicants = application?.applicants;
      const isDistributorPresent =
        !distributorId &&
        application?.distributor_id &&
        (application?.applicationstrategydetails || [])?.length > 0;
      if (distributorId || isDistributorPresent) {
        try {
          if (
            (distributorId && Number(distributorId) !== Number(application?.distributor_id)) ||
            isDistributorPresent
          ) {
            setButtonDisable(true);
            response = (await getAllStrategiesByDistributorType(dispatch, {
              ...application,
              distributor_id: distributorId,
              rm_id: rmId,
            } as ApplicationProps)) as unknown as GetStrategiesResponseBody[];
          }

          setButtonDisable(false);
          const responseId = response?.map((responseIdData) => responseIdData.id?.toString());

          if ((application?.applicationstrategydetails || [])?.length > 0 && response?.length > 0) {
            applicationStrategydetails = {
              applicationstrategydetails: (application?.applicationstrategydetails?.map(
                (_application_stratagy) => {
                  const feeDetailsCheck = response
                    .find(
                      (_stratagy_id) =>
                        Number(_stratagy_id.id) === Number(_application_stratagy?.strategyId)
                    )
                    ?.strategyFeeDetails?.map((_feeDetails) => _feeDetails.id)
                    .includes(_application_stratagy?.strategyFeeDetailId || '');
                  if (!responseId.includes(_application_stratagy?.strategyId?.toString())) {
                    strategiesFeeType = '';
                    return {
                      ..._application_stratagy,
                      isActive: false,
                    };
                  }
                  if (!feeDetailsCheck) {
                    strategiesFeeType = '';
                    return {
                      ..._application_stratagy,
                      isActive: false,
                    };
                  }
                  return _application_stratagy;
                }
              ) || []) as StrategyDetailsType[],
            };
          }
        } catch (e) {
          setButtonDisable(false);
          console.error((e as Error).message);
        }
      }
      if (isCustodianKotak(values?.custodian || '')) {
        applicants = application?.applicants.map((_applicant) => {
          if (
            _applicant?.fatcaAddress &&
            addressForTaxsMasters[_applicant?.fatcaAddress?.address_type || ''] !==
              addressForTaxsMasters.others
          ) {
            return {
              ..._applicant,
              fatcaAddress: {
                ...(_applicant?.fatcaAddress as ApplicantAddressType),
                isActive: false,
              },
            };
          } else {
            return _applicant;
          }
        });
      }

      const checkApplication = handleapplicationComparison(
        values,
        application,
        applicationStrategydetails,
        strategiesFeeType,
        applicants,
        isSaveLater
      );

      //save for later route for investor at liveliness
      const investorEditSaveelaterRoute =
        referenceIdForInvestorPhotoCapture &&
        saveForLaterInvestorPhotoCapture(referenceIdForInvestorPhotoCapture, application);
      const referenceIdForSaveProceedRoute = referenceIdForInvestorPhotoCapture
        ? referenceIdForInvestorPhotoCapture
        : referenceDetail.esignReferenceId;

      if (id && !checkApplication) {
        setLoading(true);
        await dispatch(
          updateApplication({
            body: {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              ...application!,
              ...applicationStrategydetails,
              applicants,
              strategiesFeeType,
              distributor_id: distributorId,
              rm_id: rmId,
              subdistributorId,
              status:
                !hasPOA &&
                AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                status !== 'draft' &&
                applyRoleBasedStatus(role)
                  ? 'sent_to_amc_approver'
                  : status,
              banks: isBankDetailsChanged(application?.bankDetails, values.bankDetails)
                ? application?.banks.length
                  ? application?.banks.map((applicant) => {
                      return { ...applicant, isActive: false };
                    })
                  : application?.banks
                : application?.banks,
              currentStep: SAVE_LATER_VALIDATION_CHECK ? 1 : isSaveLater ? 0 : 1,
              ...((!SAVE_LATER_VALIDATION_CHECK as boolean) && { saveForLater: isSaveLater }),
              //currentStep === null ? 1 : currentStep
              filledBy,
              custodian,
              bankDetails: checkNDPMS(accountType) ? bankDetails : '',
              ndpmsSectionEdited: showDialogForEdit ? true : application?.ndpmsSectionEdited,
            },
            applicationId: id,
            ...(saveType !== 'save and proceed' && {
              toastMessage: '',
            }),
          })
        );
        !isSaveLater
          ? history.push('contributor-details', {
              id,
              applicant1ReferenceId: referenceIdForSaveProceedRoute,
            })
          : referenceIdForInvestorPhotoCapture
          ? history.push(
              investorEditSaveelaterRoute.routePath,
              investorEditSaveelaterRoute.routeState
            )
          : history.push(saveForLater(role, id, referenceDetail.esignReferenceId));
      } else if (checkApplication) {
        if (isSaveLater) {
          enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
            variant: 'success',
            autoHideDuration: 3000,
          });
        }
        !isSaveLater
          ? history.push('contributor-details', {
              id,
              applicant1ReferenceId: referenceIdForSaveProceedRoute,
            })
          : referenceIdForInvestorPhotoCapture
          ? history.push(
              investorEditSaveelaterRoute.routePath,
              investorEditSaveelaterRoute.routeState
            )
          : history.push(saveForLater(role, id, referenceDetail.esignReferenceId));
      }
    } catch (e) {
      typeof e === 'string' && dispatch(showError(e));
      setLoading(false);
      console.error((e as Error).message);
    }
  };

  const manageSubmit = (values: DistributorDetailsProps) => {
    const { bankAccountFormCreated = false, showBankIcon = false } = application || {};
    const { bankDetails = '' } = values;
    const checkApplication = applicationComparison(application, {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      ...application,
      bankDetails: checkNDPMS(accountType) ? bankDetails : '',
    });
    if (
      showPopBankDetail(
        checkApplication,
        accountType,
        bankAccountFormCreated,
        showBankIcon,
        bankDetails,
        role
      )
    ) {
      setFinalValue(values);
      setShowShowForEdit(true);
    } else {
      onSubmit(values);
    }
  };

  const amcuserAsInvestor = refLoginCheck(
    authId,
    application as unknown as ApplicationProps,
    referenceDetail
  );

  const isFieldDisabled = [USER_ROLES.INVESTOR].includes(role) || amcuserAsInvestor;

  return (
    <Formik
      initialValues={initialValues}
      validate={(values: DistributorDetailsProps) => {
        try {
          validateYupSchema(
            values,
            distributorsValidationSchema(
              selectedDistributor,
              distributors,
              rms,
              checkNDPMS(accountType),
              shouldValidateUponSaveLater(values.saveType)
            ),
            true,
            values
          );
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}
      onSubmit={manageSubmit}
      enableReinitialize={true}>
      {({ handleSubmit, values, setValues }) => (
        <Box component="form" noValidate onSubmit={handleSubmit}>
          <Notes
            displayContent={
              'This section specifies whether the application is from an RM/Distributor’s RM.'
            }
          />
          <Grid container rowSpacing={2} columnSpacing={5} sx={{ pt: '25px !important' }}>
            {[
              USER_ROLES.RM,
              USER_ROLES.INVESTOR,
              USER_ROLES.DISTRIBUTOR,
              USER_ROLES.SUBDISTRIBUTOR,
            ].includes(role) && (
              <Grid item xs={12}>
                <UseRadioGroup
                  formLabel=""
                  name={`loginType`}
                  items={[
                    { label: 'RM', value: USER_ROLES.RM },
                    { label: 'Distributor', value: USER_ROLES.DISTRIBUTOR },
                  ]}
                />
              </Grid>
            )}
            {![USER_ROLES.POAAPPROVER].includes(role) && values.loginType === USER_ROLES.RM ? (
              <RMDetail rms={rms} values={values} />
            ) : (
              <DistributorDetail
                distributors={distributors}
                values={values}
                selectedDistributor={selectedDistributor}
                setSelectedDistributor={(subdistributors) =>
                  setSelectedDistributor(subdistributors)
                }
              />
            )}
            <Grid item xs={12}>
              <SubHeading sx={{ color: 'common.primary', letterSpacing: 0.5 + 'px' }}>
                {'Custodian Details'}
              </SubHeading>
            </Grid>
            <GridItem>
              <MFSelectField
                name={`custodian`}
                label={'Custodian Name *'}
                items={Object.keys(CustodianMaster)?.map((item) => ({
                  key: CustodianMaster[item],
                  value: item,
                }))}
                applyLabelStyles={true}
                disabled={
                  (values.loginType === USER_ROLES.DISTRIBUTOR && distributors.length === 0) ||
                  isFieldDisabled ||
                  [USER_ROLES.AMCAPPROVER].includes(role)
                }
              />
            </GridItem>
            {checkNDPMS(accountType) && (
              <>
                <Grid item xs={12}>
                  <SubHeading sx={{ color: 'common.primary', letterSpacing: 0.5 + 'px' }}>
                    {'Bank Details'}
                  </SubHeading>
                </Grid>
                <GridItem>
                  <MFSelectField
                    name={`bankDetails`}
                    label={'Bank Details *'}
                    items={Object.keys(NDPSMBankMaster).map((item) => ({
                      key: NDPSMBankMaster[item],
                      value: item,
                    }))}
                    applyLabelStyles={true}
                    disabled={
                      (values.loginType === USER_ROLES.DISTRIBUTOR && distributors.length === 0) ||
                      isFieldDisabled ||
                      disableBankDetail(
                        role,
                        application?.status,
                        application?.bankAccountFormCreated,
                        application?.showBankIcon
                      )
                    }
                  />
                </GridItem>
              </>
            )}
          </Grid>
          <OnEditDialogBox
            open={showDialogForEdit}
            setOpen={setShowShowForEdit}
            handleSubmit={onSubmit}
            values={finalvalue}
            message={'Please confirm if new bank account is not to be opened for this application'}
          />
          <FieldValidationNote />
          <ProceedSaveLater
            saveLater={() => {
              setValues({
                ...values,
                saveType: 'save for later',
              });
            }}
            saveAndProceed={() => {
              setValues({
                ...values,
                saveType: 'save and proceed',
              });
            }}
            disabled={buttonDisable}
            loader={loading}
            clickedButton={values.saveType}
          />
        </Box>
      )}
    </Formik>
  );
}
